import { Component, OnInit } from "@angular/core";

import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { ChatService } from "../../../chat.service";

@Component({
  selector: "app-chat-user-sidebar",
  templateUrl: "./chat-user-sidebar.component.html",
})
export class ChatUserSidebarComponent implements OnInit {
  public userProfile;

  constructor(
    private _chatService: ChatService,
    private _coreSidebarService: CoreSidebarService,
  ) {}

  toggleSidebar(name) {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  updateUserStatus() {
    this._chatService.updateUserProfile(this.userProfile);
  }

  ngOnInit(): void {
    this.userProfile = this._chatService.userProfile;
  }
}
